<template>
  <div class="view">
    <top-header class="view-header" />
    <dv-loading v-if="isLoading">正在加载数据...</dv-loading>
    <dv-decoration-6 style="width: 100vw; height: 5px" />
    <div class="view-tab">
      <el-button
        :type="selectedId === '0' ? 'success' : 'primary'"
        @click="onSelect('0')"
        class="view-tab-item"
        >全部</el-button
      >
      <el-button
        class="view-tab-item"
        :type="selectedId === item.cityId ? 'success' : 'primary'"
        size="large"
        v-for="(item, index) in list"
        :key="index"
        @click="onSelect(item.cityId)"
        >{{ item.cityName }}</el-button
      >
    </div>
    <dv-decoration-6 style="width: 100vw; height: 5px" />
    <div class="view-box">
      <view-item
        v-for="(item, index) in listInCity"
        :key="index"
        :param="item"
        :num="index"
      ></view-item>
    </div>
  </div>
</template>

<script>
import HTTP_SCREEN from "@/api/screen";
import HTTP_OTHER from "@/api/other";
import TopHeader from "./component/TopHeader.vue";
import ViewItem from "./component/ViewItem.vue";
export default {
  name: "screen",
  components: {
    TopHeader,
    ViewItem,
  },
  data() {
    return {
      isLoading: false,
      list: [],
      selectedId: "0",
      listInCity: [],
    };
  },
  watch: {
    selectedId: {
      immediate: true,
      handler() {
        this.initListInCity();
      },
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    initListInCity() {
      this.listInCity = [];
      if (this.selectedId === "0") {
        //全部
        this.list.forEach((item) => {
          this.listInCity = this.listInCity.concat(item.list);
        });
      } else {
        //以城市为单位
        this.list.forEach((item) => {
          if (item.cityId === this.selectedId) {
            this.listInCity = this.listInCity.concat(item.list);
          }
        });
      }
    },
    onSelect(id) {
      this.selectedId = id;
    },
    async getCity(id) {
      try {
        const res = await HTTP_OTHER.getCityList({
          provinceId: id,
        });
        if (res.code === 200) {
          return res.data;
        } else {
          return [];
        }
      } catch (e) {
        console.error(e);
        return [];
      }
    },
    async getCityName(provinceId, cityId) {
      var cityList = await this.getCity(provinceId);
      var city = cityList.find((item) => {
        return item.id === cityId;
      });
      return city;
    },
    async getData() {
      this.isLoading = true;
      try {
        const res = await HTTP_SCREEN.getSituationList();
        this.list = [];
        if (res.code === 200) {
          res.data.forEach(async (item, index) => {
            var city = await this.getCityName(item.provinceId, item.cityId);
            if (city) {
              item = {
                cityName: city.name,
                ...item,
              };
            } else {
              item = {
                cityName: "暂无数据",
                ...item,
              };
            }
            this.list.push(item);
            if (index === res.data.length - 1) {
              this.initListInCity();
            }
          });
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.view {
  width: 100%;
  height: calc(100vh - 50px);
  background-color: #030409;
  overflow: auto;
  color: #fff;
  overflow: hidden;
  background-image: url("~@/assets/bg.png");
  background-size: 100% 100%;
  box-shadow: 0 0 3px rgb(44, 44, 108);
  &-header {
    height: 10%;
  }
  &-tab {
    display: flex;
    flex-wrap: wrap;
    padding: 20px;
    &-item {
      margin-right: 20px;
    }
  }
  &-box {
    display: flex;
    flex-wrap: wrap;
    padding: 20px;
    height: calc(100% - 10% - 80px);
    overflow: auto;
  }
}
</style>
